export default [
  {
    path: "/switchboard",
    name: "switchboard",
    component: () => import("./AdminPageTemplate/NiceAdminTemplate.vue"),
  },
  {
    path: "/finance-switchboard",
    name: "finance-switchboard",
    component: () => import("./FinanceSwitchboard.vue"),
  },
  {
    path: "/school-admin-switchboard",
    name: "school-admin-switchboard",
    component: () => import("./SchoolAdminSwitchboard.vue"),
  },
];
